import { __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { node, oneOfType, string, number } from 'prop-types';
import { Heading1, Heading2 } from '../Type';
import FatalErrorNoticeIcon from './FatalErrorNoticeIcon';
import './FatalErrorNotice.less';
const FatalErrorNotice = (props) => {
    const { heading, image, subHeading, children, type, className } = props, otherProps = __rest(props, ["heading", "image", "subHeading", "children", "type", "className"]);
    return (React.createElement("section", Object.assign({ className: clsx(className, 'kal-fatal-error-notice') }, otherProps),
        heading && React.createElement(Heading1, { className: 'kal-fatal-error-notice__heading' }, heading),
        subHeading && React.createElement(Heading2, { className: 'kal-fatal-error-notice__subheading' }, subHeading),
        React.createElement("div", { className: 'kal-fatal-error-notice__image' }, image || React.createElement(FatalErrorNoticeIcon, { type: type })),
        children));
};
FatalErrorNotice.propTypes = {
    /** main error text - rendered as an h1 */
    heading: node,
    /** subHeading will be placed before the heading visually */
    subHeading: node,
    /** used to override the default image that's rendered */
    image: node,
    /** used to determine the icon shown (if no image prop is provided) */
    type: oneOfType([string, number]),
    className: string,
    children: node,
};
export default FatalErrorNotice;
//# sourceMappingURL=FatalErrorNotice.js.map